// We should take a look on lodash to check if we could replace those...
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { convertStringDates } from "@/core/date";

const isObject = (object) => {
    return object != null && typeof object === "object";
};

export const deepCopy = (object: any) => JSON.parse(JSON.stringify(object));

export const deepCopyConvertingDate = (object: any) => convertStringDates(deepCopy(object));

export const deepEqual = (object1: any, object2: any): boolean => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
            return false;
        }
    }

    return true;
};

export const shallowEqual = (object1: any, object2: any): boolean => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
};

export function caseInsensitiveGet(obj, name, defaultValue) {
    if (obj === null || obj === undefined) {
        return defaultValue;
    }
    const foundKeys = Object.keys(obj).filter((el) => el.toLowerCase() === name.toLowerCase());
    let value = null;
    if (foundKeys.length > 0) {
        value = obj[foundKeys[0]];
    }
    if (value === null || value === undefined) {
        return defaultValue;
    }
    return value;
}

export const isEmptyObject = (obj: Record<string, any>): boolean => {
    return Object.keys(obj).length === 0;
};
